import { Divider, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { PrincipalLayouts } from '../../../layouts/PrincipalLayouts'
import { fetchData } from '../../helpers/getData/fetchData'
import { DivestmentClubTable } from '../divestment/DivestmentClubTable'
import { PositionsTable } from './PositionsTable'
import { TotalPositionsClub } from './TotalPositionsClub'
import { TotalPositionSmall } from './TotalPositionSmall'
import { LPView } from './LPView'
import { DivestmentLPTable } from '../divestment/DivestmentLPTable'

export const ViewIndividualPosition = () => {

    const { t } = useTranslation('global')
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const role = searchParams.get('role');
    const [investmentList, setInvestmentList] = useState('isLoading')
    const [divestmentList, setDivestmentList] = useState('isLoading')
    const [divestmentLPList, setDivestmentLPList] = useState('isLoading')

    useEffect(() => {
        fetchData(setInvestmentList, `/investments?indiv=${searchParams.get('indiv')}`, t)
        fetchData(setDivestmentList, `/divestment?user=${searchParams.get('indiv')}`, t);
        fetchData(setDivestmentLPList, `/divestmentFund?user=${searchParams.get('indiv')}`, t);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [t])

    return (
        <PrincipalLayouts>
            {
                (investmentList !== 'isLoading' && divestmentList !== 'isLoading' && (role === 'Club' || role === 'Híbrido')) &&
                <Stack gap={8}>
                    <Stack>
                        <Typography color='primary' variant='h6'>{t('tablestitles.positionsClubGral')} ({searchParams.get('name')})</Typography>
                        <Divider sx={{ marginBottom: '45px', marginTop: '10px' }} />
                        <TotalPositionsClub investmentList={investmentList} divestmentList={divestmentList} />
                        <TotalPositionSmall investmentList={investmentList} divestmentList={divestmentList} />
                    </Stack>
                    <PositionsTable rows={investmentList} />
                    <DivestmentClubTable rows={divestmentList} />
                </Stack>
            }
            {
                ((role === 'LP' || role === 'Híbrido') && divestmentLPList !== 'isLoading') &&
                <>
                    <Stack mb={4} mt={4}>
                        <Typography color='primary' variant='h6'>{t('tablestitles.positionsLPGral')} ({searchParams.get('name')})</Typography>
                        <Divider sx={{ marginBottom: '25px', marginTop: '10px' }} />
                    </Stack>
                    <Stack gap={8}>
                        <Stack>
                            <Typography color='primary' component='h2' sx={{ typography: { md: 'h6', xs: 'subtitle1' } }}>{t('tablestitles.positionLP')}</Typography>
                            <Divider sx={{ marginBottom: '25px', marginTop: '10px' }} />
                            <LPView id={searchParams.get('indiv')} />
                        </Stack>
                        <Stack>
                            <Typography color='primary' variant='h6'>{t('tablestitles.divestmentLP')}</Typography>
                            <Divider sx={{ marginBottom: '25px', marginTop: '10px' }} />
                            <DivestmentLPTable rows={divestmentLPList} />
                        </Stack>
                    </Stack>
                </>
            }
        </PrincipalLayouts>
    )
}
